import { EnumBase } from 'hay-core-react';

class ConfiguracaoIdentificacaoMercadoPagoEnum extends EnumBase {
    constructor() {
        super(
            [
                'main.configuracao.identificacaomercadopago.emailgerado',
                'main.configuracao.identificacaomercadopago.requeremail',
            ],
            'main.configuracao.identificacaomercadopago.requeremail'
        );
    }
}

const instance = new ConfiguracaoIdentificacaoMercadoPagoEnum();
export default instance;
